import {DeviceStatus, DeviceStatusImageSrc} from "dto/realdevice/devices"
import {LatLng} from "pages/dashboard/map/MapProps"
import {ReactNode} from "react"
import {CustomOverlayMap, MapMarker} from "react-kakao-maps-sdk"
import styled from "styled-components"

interface WheelchairMarkProps {
    position: LatLng
    children?: ReactNode
    status?: DeviceStatus
    onClick?: () => void
    currentLevel: number
    minLevel: number
}

export const WheelchairMark = ({position, children, onClick, status, currentLevel, minLevel}: WheelchairMarkProps) => {
    const src = status ? DeviceStatusImageSrc[status] : "/img/mark-03.png"
    return (
        <>
            <MapMarker position={position} image={{src, size: {width: 32, height: 43}}} onClick={onClick}/>
            {currentLevel < minLevel && (
                <CustomOverlayMap position={position} yAnchor={1}>
                    <InfoPanel className="columns">
                        <InfoPanelContentIcon status={status || "STAND_BY"}/>
                        <InfoPanelContent className="column" style={{padding: 0}}>
                            {children}
                        </InfoPanelContent>
                    </InfoPanel>
                </CustomOverlayMap>
            )}
        </>
    )
}
const InfoPanel = styled.div`
  position: relative;
  bottom: 52px;
  height: 20px;
  min-width: 80px;
  border-bottom: 2px solid #4a4a4a;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`

const InfoPanelContent = styled.span`
  text-decoration: none;
  color: #0a0a0a;
  text-align: center;
  font-size: 12px;
  font-weight: bold;
  overflow: hidden;
  background: white;
  padding-top: 3px;
  height: 18px;
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
  background: rgba(255, 255, 255, 0.5);
`

const InfoPanelContentIcon = styled.a<{ status: DeviceStatus }>`
  width: 15px;
  display: block;
  text-decoration: none;
  color: #000;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  overflow: hidden;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  background: ${props => {
    let backgroundColor = "#3e8ed0"
    // #d95050
    if (props.status === "EMERGENCY") {
      // backgroundColor = "#f14668"
      backgroundColor = "hsl(348, 100%, 61%)"
    } else if (props.status === "WORKING") {
      backgroundColor = "hsl(171, 100%, 41%)"
    } else {
      backgroundColor = "#3e8ed0"
    }
    return `${backgroundColor} url(/img/arrow_white.png) no-repeat right 4px center`
  }};
  background-size: 35%;
`